export default __webpack_public_path__ + "static/media/contact.ea626d00.jpg";